import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import './influencer-phone-details.scss';

applyTranslations(require('./influencer-phone-details.i18n.json'));

type Props = {
  phoneNumber?: string | null
};

const MSG_KEY = 'influencer_phone_details';

const InfluencerPhoneDetails: React.FunctionComponent<Props> = ({ phoneNumber }: Props) => (
  <div className="influencer-phone-details__container">
    <div className="influencer-phone-details__row">
      <div className="influencer-phone-details__label">
        {__t(`${MSG_KEY}.phone_number_label`)}
      </div>
      <div className="influencer-phone-details__value">
        {phoneNumber || '–'}
      </div>
    </div>
  </div>
);


export default InfluencerPhoneDetails;
